import React, { useState } from 'react'
import PrimaryButton from '../../../global/components/buttons/primary-button/PrimaryButton'
import MakePriceChangeModal from './modal/MakePriceChangeModal'
import { ILocationServiceOrRule } from '../../../../../app/types/location-service-or-rule'
import { ROLES } from '../../../global/constants/users'



interface IMakePriceChangeProps {
  chosenLocationServiceOrRule: ILocationServiceOrRule
  refetchLocationServicesHistory: Function
}


export default function MakePriceChange({
  chosenLocationServiceOrRule,
  refetchLocationServicesHistory
}: IMakePriceChangeProps) {
  const userRole = localStorage.getItem('Role')
  const [isOpen, setIsOpen] = useState(false)

  const handleClosed = async () => {
    await refetchLocationServicesHistory()
    setIsOpen(false)
  }

  return (
    <div>
      <div>
        {userRole === ROLES.admin && (
          <>
            <MakePriceChangeModal
              isOpen={isOpen}
              handleClosed={handleClosed}
              chosenLocationServiceOrRule={chosenLocationServiceOrRule}
            />
            <PrimaryButton
              buttonName="Make Price Change"
              onClick={() => setIsOpen(true)}
            />
          </>
        )}
      </div>
    </div>
  )
}
